<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">HomePage</a>
    </div>
    <!-- page actions -->
    <div class="page-actions">
      <h2>HomePage</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="toHomePageEdit">
        <v-icon class="mr-2">edit</v-icon>
        <span class="mr-2">編輯</span>
      </button>
    </div>
    <!-- block 1 -->
    <div class="block" style="min-height: 70vh; margin-bottom: 30px;">
      <PageMenu :sections="sections">
        <component :is="sectionView" :homepage="homepage"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BrandVisual from '@/views/B-1__HomePage/c/B-1-1-1_HomePage_BrandVisual.vue';
import BrandMessaging from '@/views/B-1__HomePage/c/B-1-1-2_HomePage_BrandMessaging.vue';
import BuSections from '@/views/B-1__HomePage/c/B-1-1-3_HomePage_BU_Sections.vue';
import PageMenu from '@/components/PageMenu.vue';

export default {
  components: {
    BrandVisual,
    BrandMessaging,
    BuSections,
    PageMenu,
  },
  data: () => ({
    sections: [
      {
        name: 'Brand Visual',
        component: 'BrandVisual',
      },
      {
        name: 'Brand Messaging',
        component: 'BrandMessaging',
      },
      {
        name: 'BU Sections',
        component: 'BuSections',
      },
    ],
  }),
  async created() {
    if (this.homepage === null) {
      await this.getHomepage();
    }
  },
  computed: {
    ...mapState('homepage', ['homepage']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  methods: {
    ...mapActions('homepage', {
      getHomepage: 'find',
    }),
    toHomePageEdit() {
      this.$router.push({
        name: 'HomePageEdit',
        query: {
          section: this.$route.query.section,
        },
      });
    },
  },
};
</script>
<style></style>
